import React, { useState, useRef } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useAuth } from "../../context/AuthContext";
import AuthBackground from "../../components/Home/AuthBackground/AuthBackground ";
import { TbMailFilled } from "react-icons/tb";
import img from "../../assets/users/logo.png";

function AdminLoginOTP() {
  const {
    Adminlogin,
    isAuthenticated,
    user,
    sellerRequestOTP,
    sellerVerifyOTP,
  } = useAuth();
  const navigate = useNavigate();

  const [loginMethod, setLoginMethod] = useState("otp"); // 'otp' or 'password'
  const [step, setStep] = useState("request");
  const [email, setEmail] = useState("");
  const [otpDigits, setOtpDigits] = useState(Array(6).fill(""));
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const otpRefs = useRef([]);

  // const [formData, setFormData] = useState({
  //   username: "",
  //   password: "",
  // });
   const [formData, setFormData] = useState({
    identifier: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);

  const handleToggleMethod = (method) => {
    setLoginMethod(method);
    setStep("request");
    setError(null);
    setSuccessMessage(null);
  };

  // Handle OTP Input Change
  const handleOtpChange = (index, value) => {
    if (!/^\d?$/.test(value)) return; // Allow only single-digit numbers

    const newOtp = [...otpDigits];
    newOtp[index] = value;
    setOtpDigits(newOtp);

    if (value && index < 5) {
      otpRefs.current[index + 1]?.focus(); // Move forward
    } else if (!value && index > 0) {
      otpRefs.current[index - 1]?.focus(); // Move backward on Backspace
    }
  };

  const handleOtpKeyDown = (index, e) => {
    if (e.key === "Backspace" && otpDigits[index] === "" && index > 0) {
      otpRefs.current[index - 1].focus();
    }
  };

  // Handle paste event to allow pasting a complete OTP.
  const handleOtpPaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text").trim();
    // Only process if the pasted data is numeric.
    if (/^\d+$/.test(pasteData)) {
      const digits = pasteData.split("").slice(0, otpDigits.length);
      // Create a new array with pasted digits and fill missing entries with empty strings.
      const newOtpDigits = Array(otpDigits.length)
        .fill("")
        .map((_, i) => digits[i] || "");
      setOtpDigits(newOtpDigits);
      // Focus the last input if paste fills all fields.
      if (digits.length >= otpDigits.length) {
        otpRefs.current[otpDigits.length - 1].focus();
      } else {
        otpRefs.current[digits.length].focus();
      }
    }
  };

  // Handle OTP Request
  const handleRequestSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccessMessage(null);

    if (!email) {
      setError("Please enter your email.");
      return;
    }

    setIsLoading(true);
    const result = await sellerRequestOTP(email);
    setIsLoading(false);

    if (result.success) {
      setSuccessMessage("OTP sent successfully. Check your email.");
      setStep("verify");
    } else {
      setError(result.message);
    }
  };

  const handleResendOTP = async () => {
    setError(null);
    setSuccessMessage(null);

    if (!email) {
      setError("Please enter your email.");
      return;
    }

    const result = await sellerRequestOTP(email);

    if (result.success) {
      setSuccessMessage("OTP has been resent successfully.");
    } else {
      setError(result.message);
    }
  };

  // Handle OTP Verification
  const handleVerifySubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccessMessage(null);

    const otp = otpDigits.join("");
    if (otp.length < 6) {
      setError("Please enter a complete 6-digit OTP.");
      return;
    }

    setIsLoading(true);
    const result = await sellerVerifyOTP(email, otp);
    setIsLoading(false);
    console.log("Login successful");
    console.log("User data:", result);
    if (result.success) {
      if (result.data.Data.user_type === "admin") {
        navigate("/admin");
      } else if (result.data.Data.user_type === "subadmin") {
        navigate("/subadmin");
      }
    } else {
      setError(result.message);
    }
  };

  // Handle Password Login
  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);

    if (!formData.identifier || !formData.password) {
      setError("Please fill in both fields.");
      setIsLoading(false);
      return;
    }

    try {
      const success = await Adminlogin(formData);
      console.log("Login successful");
      console.log("User data:", success);
      if (success.success) {
        if (success.data.Data.user_type === "admin") {
          navigate("/admin");
        } else if (success.data.Data.user_type === "subadmin") {
          navigate("/subadmin");
        }
      } else {
        setError("Invalid username or password.");
      }
    } catch (error) {
      setError("An error occurred. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  // if (isAuthenticated && user.user_type === "seller") {
  //   return <Navigate to="/admin" />;
  // }

  return (
    <div className="grid h-screen w-screen grid-cols-1 md:grid-cols-2">
      <AuthBackground />
      <div className="flex flex-col items-center justify-center md:h-full">
        <div className="flex w-full flex-col items-start rounded-xl border-0 border-solid px-5 sm:w-[450px] md:border-2 md:p-10">
          {/* Toggle Buttons */}
          <div className="my-5 text-start text-3xl font-semibold md:text-2xl">
            <p>Sign In</p>
          </div>

          <div className="flex w-full gap-1 rounded-lg bg-[#FFAE00] p-2 text-center">
            <button
              onClick={() => handleToggleMethod("otp")}
              className={`flex-1 rounded-md py-1 text-sm font-semibold transition-all duration-300 ${
                loginMethod === "otp"
                  ? "bg-white text-black shadow-md"
                  : "bg-transparent text-black"
              }`}
            >
              Sign In with OTP
            </button>
            <button
              onClick={() => handleToggleMethod("password")}
              className={`flex-1 rounded-md py-1 text-sm font-semibold transition-all duration-300 ${
                loginMethod === "password"
                  ? "bg-white text-black shadow-md"
                  : "bg-transparent text-black"
              }`}
            >
              Sign In with Password
            </button>
          </div>

          <hr className="border-1 border-graylight my-8 w-full border-solid" />

          {/* OTP Login */}
          {loginMethod === "otp" && (
            <>
              {step === "request" ? (
                <form className="w-full" onSubmit={handleRequestSubmit}>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Email ID*"
                    className="mb-5 w-full rounded-md border border-green-500 bg-gray-100 p-2"
                    required
                  />
                  {error && <p className="text-sm text-red-500">{error}</p>}
                  <button
                    type="submit"
                    className="w-full rounded-xl bg-[#FFAE00] px-6 py-2 font-bold text-black"
                    disabled={isLoading}
                  >
                    {isLoading ? "Sending OTP..." : "Get OTP"}
                  </button>
                </form>
              ) : (
                <form className="w-full" onSubmit={handleVerifySubmit}>
                  <p className="mb-2 text-center text-gray-600">
                    Enter OTP received on Email ID
                  </p>
                  <p className="mb-5 flex items-center justify-center gap-2 text-center text-sm font-semibold text-gray-600">
                    <TbMailFilled className="text-lg text-[#FFAE00]" />
                    {email}
                  </p>

                  <div className="flex justify-center gap-2">
                    {otpDigits.map((digit, index) => (
                      <input
                        key={index}
                        ref={(el) => (otpRefs.current[index] = el)}
                        type="text"
                        value={digit}
                        onChange={(e) => handleOtpChange(index, e.target.value)}
                        onKeyDown={(e) => handleOtpKeyDown(index, e)}
                        onPaste={handleOtpPaste}
                        maxLength="1"
                        className="h-9 w-9 rounded-md border border-green-500 text-center md:h-12 md:w-12"
                      />
                    ))}
                  </div>

                  {error && (
                    <p className="mt-2 text-sm text-red-500">{error}</p>
                  )}
                  <p className="mt-5 text-center text-sm text-gray-600">
                    Didn't get the OTP?
                  </p>
                  <p
                    className="mt-2 cursor-pointer text-center font-bold text-green-500 transition-all duration-200 hover:text-green-600 active:scale-95 disabled:opacity-50"
                    onClick={handleResendOTP}
                  >
                    Resend OTP via email
                  </p>

                  <button
                    type="submit"
                    className="mt-4 w-full rounded-xl bg-[#FFAE00] px-6 py-2 font-bold text-black"
                  >
                    {isLoading ? "Verifying OTP..." : "Confirm"}
                  </button>
                </form>
              )}
            </>
          )}

          {/* Password Login Form */}
          {loginMethod === "password" && (
            <form className="w-full" onSubmit={handleLoginSubmit}>
              <input
                type="text"
                name="identifier"
                value={formData.identifier}
                onChange={(e) =>
                  setFormData({ ...formData, identifier: e.target.value })
                }
                placeholder="Email or Mobile"
                className="mb-4 w-full rounded-md border border-brand-primary bg-gray-100 p-2"
                required
              />

              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={formData.password}
                  onChange={(e) =>
                    setFormData({ ...formData, password: e.target.value })
                  }
                  placeholder="Password"
                  className="mb-4 w-full rounded-md border border-brand-primary bg-gray-100 p-2 pr-10"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute inset-y-0 bottom-3 right-3 flex items-center"
                >
                  {showPassword ? (
                    <FaEyeSlash className="text-gray-500" />
                  ) : (
                    <FaEye className="text-gray-500" />
                  )}
                </button>
              </div>

              {/* Error Message Display */}
              {error && <p className="mt-2 text-sm text-red-500">{error}</p>}
              {successMessage && (
                <p className="text-ForestGreen mb-4 text-sm">
                  {successMessage}
                </p>
              )}

              <Link to="/forgetpassword">
                <p className="cursor-pointer text-end text-sm text-[#FFAE00]">
                  Forget Password?
                </p>
              </Link>

              <button
                type="submit"
                className="mt-4 w-full rounded-xl bg-[#FFAE00] px-6 py-2 font-semibold text-black"
              >
                {isLoading ? "Logging in..." : "Login"}
              </button>
              <div className="mt-5 flex flex-row justify-between text-center text-xs md:text-sm">
                {/* <p className=""> Don't have an account?
                  <span className="cursor-pointer font-semibold text-[#FFAE00] p-2">
                    <Link to="/seller/register">Register</Link>
                  </span>
                </p> */}
              </div>
            </form>
          )}

          {/* Footer Logo */}
          <div className="mt-10 flex w-full items-center justify-center">
            <img src={img} alt="Bricks n Mix" className="h-12" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminLoginOTP;
